import { render, staticRenderFns } from "./MySchools.vue?vue&type=template&id=3d3f021a&scoped=true&"
import script from "./MySchools.vue?vue&type=script&lang=js&"
export * from "./MySchools.vue?vue&type=script&lang=js&"
import style0 from "./MySchools.vue?vue&type=style&index=0&id=3d3f021a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f021a",
  null
  
)

export default component.exports